export default {
  template: `
    <div class="brand-loader sling-animate">
      <div></div>
      <div></div>
      <div></div>
    </div>
  `,
};
